export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-7.39aec8c6.svg";